<template>
    <div>
        <v-container>
            <v-row style="padding: 5px;">
                <v-col cols="12" sm="6" v-for="action in mainActions" :key="action.title">
                    <v-btn block color="primary" x-large @click="openActionDialog(action)">{{ action.title }} ({{ action.actionPoints }}AP)</v-btn>
                </v-col>
            </v-row>
            <v-row style="background-color: lightgray; border-radius: 3px; padding: 5px;" v-if="roleActions && roleActions.length > 0">
                <v-col cols="12" sm="6" v-for="action in roleActions" :key="action.title">
                    <v-btn block color="secondary" x-large :disabled="action.type != 'dummy'" @click="openActionDialog(action)">{{ action.title }} ({{ action.actionPoints }}AP)</v-btn>
                </v-col>
            </v-row>
            <v-row style="padding: 5px;">
                <v-col cols="12" sm="6">
                    <v-btn block color="primary" x-large @click="showRequestHelpDialog = true">Ask for Help</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-btn block color="primary" x-large @click="showMeetingDialog = true">Arrange Meeting</v-btn>
                </v-col>
            </v-row>

            <action-dialog v-model="showActionDialog" :action="selectedAction"/>
            <meeting-dialog v-model="showMeetingDialog"/>
            <request-help-dialog v-model="showRequestHelpDialog"/>
        </v-container>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ActionDialog from '../components/ActionDialog.vue';
import MeetingDialog from '../components/MeetingDialog.vue';
import RequestHelpDialog from '../components/RequestHelpDialog.vue';

export default {
    name: "Role",
    components: {
        ActionDialog,
        MeetingDialog,
        RequestHelpDialog
    },
    data: () => ({
        mainActions: [
            {
                title: "Paperwork",
                actionPoints: 1,
                alwaysSuccess: true
            },
            {
                title: "Training",
                actionPoints: 1,
                alwaysSuccess: true
            }
        ],
        showActionDialog: false,
        showMeetingDialog: false,
        selectedAction: {},
        showRequestHelpDialog: false
    }),
    methods: {
        openActionDialog(action) {
            this.showActionDialog = true;
            this.selectedAction = action;
        }
    },
    computed: mapState({
        roleActions: state => state.role?.additionalActions || []
    })
}
</script>
